module.exports = __webpack_public_path__ + "static/media/298279.024f35d3.png";